<template>
  <div>
    <vx-card title="Download Data">

    </vx-card>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>